'use client';
import { PrimeReactProvider } from 'primereact/api';

export function PrimeProvider({ children }) {
  return (
    <PrimeReactProvider value={{ ripple: true }}>
      {children}
    </PrimeReactProvider>
  );
}
